import React from 'react';
import {StyleSheet, TouchableWithoutFeedback, View} from 'react-native';
import {useDispatch, useSelector} from 'react-redux';
import RoomStatus from "../components/RoomStatus";
import {getBookModalVisibility, getConfig, setBookingListExtended,} from "../reducers/configSlice";
import BookingsSchedule from "../components/BookingsSchedule";
import useBookingListInterval from "../services/hooks/useBookingListInterval";
import useIntervalMaintenanceStatus from "../services/hooks/useIntervalMaintenanceStatus";
import useIntervalCurrentBooking from "../services/hooks/useIntervalCurrentBooking";
import useRoomStatusVisibility from "../services/hooks/useRoomStatusVisibility";
import useSoketiBookingInterval from "../services/hooks/useSoketiBookingInterval";
import NextBookingDetails from "../components/Home/NextBookingDetails";
import RoomInfo from "../components/Home/RoomInfo";
import RoomDetails from "../components/Home/RoomDetails";
import ModalsContainer from "../components/Home/ModalsContainer";
import useSoketiMaintenanceInterval from "../services/hooks/useSoketiMaintenanceInterval";

const Home  = () => {
    const config = useSelector(getConfig)
    const bookModalVisible = useSelector(getBookModalVisibility)
    const dispatch = useDispatch()
    const hideRoomStatus = useRoomStatusVisibility();

    useBookingListInterval();
    useIntervalCurrentBooking();
    useIntervalMaintenanceStatus();
    useSoketiBookingInterval();
    useSoketiMaintenanceInterval();

    return (
        <View style={[styles.containerWrapper]}>
            <ModalsContainer/>

            <View style={[styles.container, bookModalVisible && {opacity: 0}]}>
                <View style={[styles.wrapper, hideRoomStatus && {flex: 1}]}>
                    <BookingsSchedule />
                    <TouchableWithoutFeedback onPress={() => dispatch(setBookingListExtended(false))}>
                        <View style={styles.mainView}>
                            <RoomInfo/>
                            <RoomDetails/>
                            <NextBookingDetails/>
                        </View>
                    </TouchableWithoutFeedback>
                </View>
                <RoomStatus hidden={hideRoomStatus} />
            </View>
        </View>
    )
}

const styles = StyleSheet.create({
    containerWrapper: {
        flex: 1,
        width: '100%',
        height: '100%',
        justifyContent: 'space-between',
    },
    container: {
        flex: 1,
        width: '100%',
        height: '100%',
    },
    wrapper: {
        flex: 0.87,
        flexDirection: 'row'
    },
    mainView: {
        flex: 0.90,
        paddingLeft: '11.3%',
        paddingRight: '4.5%',
    },
});

export default Home
